import { render, staticRenderFns } from "./supplierCouponList.vue?vue&type=template&id=769b96ac&scoped=true"
import script from "./supplierCouponList.vue?vue&type=script&lang=js"
export * from "./supplierCouponList.vue?vue&type=script&lang=js"
import style0 from "./supplierCouponList.vue?vue&type=style&index=0&id=769b96ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769b96ac",
  null
  
)

export default component.exports